// extracted by mini-css-extract-plugin
export var downArrow = "_8p-0";
export var infoTooltipIcon = "_8p-3";
export var label = "_8p-1";
export var optionCard = "_8p-4";
export var upArrow = "_8p-2";